import FileEnterpriseRepository from '@/shared/http/repositories/realestate/fileenterprise'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'Colapseimage',
  props: ['id', 'title', 'dataImg', 'enterpriseid', 'group', 'posicaoEnum', 'posicaoEnumExclusao', 'flAdd', 'isPdf'],
  data () {
    return {
      changeAngel: false,
      loadingImg: false,
      escondeArquivo: null,
      exclusao: false,
      dataFiles: [],
      arquivoCarrecamento: false
    }
  },
  mounted () {
  },
  watch: {
    posicaoEnumExclusao (value) {
      this.exclusao = true
      this.changeAcording(value)
    },
    posicaoEnum (value) {
      this.changeAcording(value)
    }
  },
  methods: {
    changeAcording (value) {
      if (this.exclusao === true) {
        this.escondeArquivo = this.group
        this.arquivoCarrecamento = false
      }
      if (value >= 0 && this.exclusao === false) {
        this.escondeArquivo = value
      } else {
        this.escondeArquivo = this.group
        this.arquivoCarrecamento = false
      }
      this.changeAngel = !this.changeAngel
      FileEnterpriseRepository.GetAllByEnterpriseByTypeEnum({EmpreendimentoID: this.enterpriseid, Tipo: this.escondeArquivo})
        .then(Response => {
          this.exclusao = false
          this.escondeArquivo = null
          this.dataFiles = Response.data.data
          this.arquivoCarrecamento = true
        })
        .catch(Error => loading.pop())
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/colapseimage/colapseimage.js